import { createRoutes } from '@axa-fr-axion/router';
import { NavigationPath } from 'interfaces';
import { lazy } from 'react';
import lazyWithPreload from 'react-lazy-with-preload';
import { LoaderComponent } from 'stores/application/application';

// Start Routes Creation
// 1 - Vehicle
const VehicleIdentificationChoice = lazyWithPreload(() => import('features/vehicle-identification-choice/VehicleIdentificationChoice'));
const LicensePlateIdentification = lazyWithPreload(() => import('features/Vehicle/license-plate-identification/LicensePlateIdentification'));
const BrandIdentification = lazyWithPreload(() => import('features/Vehicle/brand-identification/BrandIdentification'));
const ModelIdentification = lazyWithPreload(() => import('features/Vehicle/model-identification/ModelIdentification'));
const CirculationDate = lazyWithPreload(() => import('features/Vehicle/circulation-date/CirculationDate'));
const BodyType = lazyWithPreload(() => import('features/Vehicle/body-type/BodyType'));
const MotorizationType = lazyWithPreload(() => import('features/Vehicle/motorization-type/MotorizationType'));

// 2 - Profile
const Birthdate = lazyWithPreload(() => import('features/profile/birthday/BirthdateStep'));
const Licence = lazyWithPreload(() => import('features/profile/licence/Licence'));
const BonusPenaltyCoefficient = lazyWithPreload(() => import('features/profile/bonus-penalty-coefficient/BonusPenaltyCoefficient'));
const InsuranceDelay = lazyWithPreload(() => import('features/insurance-delay/InsuranceDelay'));

// 3 - Informations
const Contact = lazyWithPreload(() => import('features/contact/Contact'));

// 4 - Tarifs
const Pricing = lazyWithPreload(() => import('features/pricing/Pricing'));

// 5 - Validation
const ChooseAdvisor = lazyWithPreload(() => import('features/choose-advisor/ChooseAdvisor'));

// Navigation
const TechnicalError = lazyWithPreload(() => import('features/technical-error/TechnicalError'));
const Scenarios = lazy(() => import('features/scenarios/Scenarios'));

// Final step
const End = lazy(() => import('features/end/End'));

export const CreateRoutesComponents: Function = () => createRoutes<NavigationPath>(
    [
        {
            path: 'VehicleIdentificationChoice',
            element: <VehicleIdentificationChoice preload={ () => LicensePlateIdentification.preload() } />,
            fallback: LoaderComponent,
        },
        {
            path: 'LicensePlateIdentification',
            element: <LicensePlateIdentification preload={ () => Birthdate.preload() } />,
            fallback: LoaderComponent,
        },
        {
            path: 'BrandIdentification',
            element: <BrandIdentification preload={ () => ModelIdentification.preload() } />,
            fallback: LoaderComponent,
        },
        {
            path: 'ModelIdentification',
            element: <ModelIdentification preload={ () => CirculationDate.preload() } />,
            fallback: LoaderComponent,
        },
        {
            path: 'CirculationDate',
            element: <CirculationDate preload={ () => BodyType.preload() } />,
            fallback: LoaderComponent,
        },
        {
            path: 'BodyType',
            element: <BodyType preload={ () => MotorizationType.preload() } />,
            fallback: LoaderComponent,
        },
        {
            path: 'MotorizationType',
            element: <MotorizationType preload={ () => Birthdate.preload() } />,
            fallback: LoaderComponent,
        },
        {
            path: 'Birthdate',
            element: <Birthdate preload={ () => Licence.preload() } />,
            fallback: LoaderComponent,
        },
        {
            path: 'Licence',
            element: <Licence preload={ () => BonusPenaltyCoefficient.preload() } />,
            fallback: LoaderComponent,
        },
        {
            path: 'BonusPenaltyCoefficient',
            element: <BonusPenaltyCoefficient preload={ () => InsuranceDelay.preload() } />,
            fallback: LoaderComponent,
        },
        {
            path: 'InsuranceDelay',
            element: <InsuranceDelay preload={ () => Contact.preload() } />,
            fallback: LoaderComponent,
        },
        {
            path: 'Contact',
            element: <Contact />,
            fallback: LoaderComponent,
        },
        {
            path: 'Pricing',
            element: <Pricing />,
            fallback: LoaderComponent,
        },
        {
            path: 'Error',
            element: <TechnicalError />,
            fallback: LoaderComponent,
        },
        {
            path: 'ChooseAdvisor',
            element: <ChooseAdvisor />,
            fallback: LoaderComponent,
        },
        {
            path: 'End/*',
            element: <End />,
            fallback: LoaderComponent,
        },
        {
            path: 'Scenarios',
            element: <Scenarios />,
            fallback: LoaderComponent,
        },

    ]
);
